import { render } from "./MemoriesHeading.vue?vue&type=template&id=f91a947a&scoped=true"
import script from "./MemoriesHeading.vue?vue&type=script&lang=js"
export * from "./MemoriesHeading.vue?vue&type=script&lang=js"

import "./MemoriesHeading.vue?vue&type=style&index=0&id=f91a947a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f91a947a"

export default script